import { clsx } from 'clsx'

type Granularity = 'hour' | 'day' | 'week'

const OPTIONS: Granularity[] = ['hour', 'day', 'week']

interface GranularitySelectorProps {
  value: Granularity
  onChange: (v: Granularity) => void
}

export function GranularitySelector({
  value,
  onChange,
}: GranularitySelectorProps): React.JSX.Element {
  return (
    <div className="inline-flex rounded-lg border border-surface-3 p-0.5">
      {OPTIONS.map((opt) => (
        <button
          type="button"
          key={opt}
          onClick={() => onChange(opt)}
          className={clsx(
            'rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
            value === opt
              ? 'bg-brand-500 text-white'
              : 'text-text-secondary hover:text-text-primary',
          )}
        >
          {opt.charAt(0).toUpperCase() + opt.slice(1)}
        </button>
      ))}
    </div>
  )
}
